import { OpaSubscription } from '@models/Opa';
import { createContext } from 'react';

// Define Context Shape (Allow `null` for initial loading)
export interface SubscriptionsConfig {
  subscriptions: OpaSubscription;
  loadingSubscriptions: boolean; // This variable is to determine whether subscriptions is loaded or not , false = finish loaded
}

// Create Context with a Default Value (`null` initially)
export const SubscriptionsContext = createContext<SubscriptionsConfig>({
  subscriptions: {} as OpaSubscription,
  loadingSubscriptions: true,
});
